const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/users`,
    information: `${API_URL}/user/information`
};

export default apiUrls;
